module.exports = require("@leafygreen-ui/code");